import { getAuthToken } from '@/assets/js/Authentication'
import HttpRequest from './HttpRequest'

class SchedulingProvider extends HttpRequest {
  async reQuery () {
    this.setHeader(getAuthToken())
    return this.create('/scheduling/find-and-requery')
  }
}

export default SchedulingProvider
